import ContactModel from "../Contact/ContactModel";
import _ from "underscore";
import Backbone from "backbone";
import RecaptchaHandler from "../utils/RecaptchaHandler";

require("backbone-validator.js");

module.exports = Backbone.View.extend({

    el: "body",

    initialize: function(options) {
        _.extend(this, options);

        this.model = new ContactModel({
            trans: options.trans
        });
    },

    events: {
        "click #btnExtraInfo_submit": "save",
    },

    bindings: {
        "[name='voornaam']": "voornaam",
        "[name='naam']": "naam",
        "[name='tel_nr']": "tel_nr",
        "[name='gsm_nr']": "gsm_nr",
        "[name='email']": "email",
        "[name='message']": "text",
        "[name='verlangt_andere_communicatie']": "verlangt_andere_communicatie", // not required
    },

    // rebind when form is displayed with modal
    bindForm () {
        for (const field in this.bindings) {
            this.model.attributes[this.bindings[field]] = $(field)[0].value;
        }
    },

    // More info
    save: function (e) {
        e.preventDefault();
        this.bindForm();
        const  buttenEl =  $("#btnExtraInfo_submit");
        buttenEl
            .attr("disabled", "disabled")
            .addClass("btn-disabled");

        if (!this.model.isValid()) {
            let data = {};
            data["errors"] = this.model.validate();
            this.handleErrors(data);
        } else {
            const that = this;
            RecaptchaHandler.handle(
                $('#frmExtraInfo').serialize(),
                function (data) {
                    that.sendMoreInfo(data);
                }
            );
        }
    },

    sendMoreInfo: function(form) {
        let that  = this;
        $.ajax({
            type: "POST",
            url: base_dir + '/' + url_language + '/ajax/more-info/',
            data: form,
            success: (data) => {
                //sluit bestaande venster eerst
                data = $.parseJSON(data);
                var title = '';
                if (data.title != '' && data.title != null) {
                    title = data.title;
                }
                if(!data.error){
                    $('#mdlExtraInfo .close').trigger('click');
                    bootbox_message_box(data.message, 'success', title);
                    if($("#frmExtraInfo")[0]) {
                        $("#frmExtraInfo")[0].reset();
                    }
                    if (this.$el.attr( 'data-pagetype') == "property-detail") {
                        if (typeof _gaq === "object") {
                            _gaq.push(['_trackEvent', 'Contact', 'sent', 'property detail page', , true]);
                        }
                        ;
                        Tracking.fbTrackEvent("Contact property detail page sent");
                    }
                } else if(data.error) {
                    that.handleErrors(data);
                }//end of if data.message not empty
            },//end of success function
            error: function () {
                $("#mdlExtraInfo .alert").remove();
                $('<div class="alert alert-danger"></div>').text(unknown_error).appendTo("#mdlMail2Friend .modal-header");
            }
        });//end of ajax
    },

    handleErrors: function (data) {
        const buttenEl =  $("#btnExtraInfo_submit");
        let messageBox = '';
        const errors = data.errors;
        if (data.message != '' && data.message != null) {
            messageBox += '<div class="errors">' + data.message + '</div>';
        }
        if (errors) {
            messageBox += '<ul class="errors">';
            for(const e in errors){
                messageBox += '<li>' + errors[e] + '</li>';
            }
            messageBox += '</ul>';
        }
        $('.bootbox_message_box').remove();
        $("#mdlExtraInfo .alert").remove();
        $('<div class="alert alert-danger"></div>').html(messageBox).appendTo("#mdlExtraInfo .modal-header");
        buttenEl
            .removeAttr("disabled")
            .removeClass("btn-disabled");
    }

});
